import { render, staticRenderFns } from "./ReportEducations.vue?vue&type=template&id=ea5c76de&"
import script from "./ReportEducations.vue?vue&type=script&lang=ts&"
export * from "./ReportEducations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports